<style src="css/timeSetting.css" scoped></style>
<template>
    <div style="padding-top: .98rem">
        <topbar text="时间设置"></topbar>
        <div class="mainBox">
            <div class="notice">
                <div class="noticeTitle">说明：</div>
                <div class="noticeEntry">1.点击设置时间，再次点击取消设置。</div>
<!--                <div class="noticeEntry">2.不可设置临近已设置一小时内的时间。</div>-->
                <div class="noticeEntry">2.当前时间15分钟内的用户不可见。</div>
            </div>
            <div class="timeBox">
                <div class="timeItem" v-for="item in dateVale" :class="{active:item.status}" @click="item.status=!item.status">{{item.time}}</div>
            </div>
        </div>
        <div class="btnBox" @click="doctorScheduleSet">保存设置</div>
    </div>
</template>
<script>
    import {getSource, getSources} from "../api"

    import noMoreData from 'components/no-more-data'
    import topbar from 'components/topbar'
    import moment from 'moment/moment'

    import eventBus from '../eventBus'

    import Vue from 'vue'

    import {serialize} from 'utils/index'

    export default {
        data() {
            return {
//                EnvUrl: `https://oml9ntix5.qnssl.com/`, // 七牛图片
                EnvUrl: `https://cdn.ysqingxin.com/`,
                dateVale:[],
                scheduleId:'',
            }
        },
        components: {
            noMoreData,
            topbar,
        },
        filters: {

            time(value) {
                let transTime = moment(value).format('YYYY-MM-DD HH:mm:ss')
                return transTime
            },
        },
        computed: {},
        methods: {
            async doctorScheduleSet() {
                let arr=[]
                this.dateVale.forEach(v=>{
                    if(v.status){
                        arr.push(v.time)
                    }
                })
                let obj = {
                    scheduleId:this.scheduleId,
                    doctorId:localStorage.getItem('doctorId'),
                    dateValue:JSON.stringify(arr)
                }
                let data = await getSources("/bear-scale/api/chatDoctor/doctorScheduleSet.json", obj);
                if (data.status === 0) {
                    alert('时间设置成功')
                  //传递一个map，choiceHospital是key，hospital是value
                  eventBus.$emit('type',this.$route.query.type);
                  //调用router回退页面
                  this.$router.go(-1);
                    // this.$router.replace(`/scheduling?type=${this.$route.query.type}`)
                }else{
                    alert(data.msg)
                }
            },
            async getScheduleToSet() {
                let obj = {}
                let data = await getSources("/bear-scale/api/chatDoctor/getScheduleToSet.json", obj);
                if (data.status === 0) {
                    let arr=JSON.parse(data.dateVale)
                    console.log(arr)
                    let array=[]
                    arr.forEach(v=>{
                        array.push({
                            time:v,
                            status:false
                        })
                    })
                    this.dateVale=array
                }else{
                    alert(data.msg)
                }
            },
        },
        destroyed(){

        },
        mounted() {
                  console.log(history)
            this.scheduleId=this.$route.query.scheduleId
            this.getScheduleToSet()
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/timeSetting.vue